import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import { Col, Form, Modal, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "helpers/api";
import { useState } from "react";

interface AddLeadModalProps {
  show: boolean;
  handleClose: () => void;
  setCollaborators: any;
  collaborators: any;
}

type Inputs = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  status: string;
};

const AddCollaboratorModal = ({
  show,
  handleClose,
  setCollaborators,
}: AddLeadModalProps) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const [loading, setLoading] = useState(false);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("/collaborators", {
        collaborator_first_name: data.first_name,
        collaborator_last_name: data.last_name,
        collaborator_email: data.email,
        collaborator_phone: data.phone,
        collaborator_status: data.status,
      });

      setCollaborators(response.data.data.collaborators);
      toast.success(response.data.message);
      reset();
      handleClose();
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
    setLoading(false);
  };

  return (
    <Modal
      size="lg"
      show={show}
      centered
      backdrop="static"
      onHide={handleClose}
      contentClassName="bg-body-highlight p-6 border border-translucent"
    >
      <Modal.Header className="border-0 p-0 mb-2">
        <h3 className="mb-0">Add Collaborator</h3>
        <Button
          variant="phoenix-secondary"
          className="ms-auto"
          onClick={handleClose}
          size="sm"
        >
          <FontAwesomeIcon icon={faTimes} className="text-danger" />
        </Button>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="px-0 mb-6">
          <Row className="g-3">
            <Col lg={6}>
              <Form.Group>
                <Form.Label>
                  First Name<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="First Name"
                  {...register("first_name", {
                    required: true,
                    maxLength: 100,
                  })}
                />
              </Form.Group>
              {errors.first_name?.type === "required" && (
                <p role="alert" className="text-danger fs-9 pt-1 mb-0">
                  First name is required
                </p>
              )}
            </Col>
            <Col lg={6} className="">
              <Form.Group>
                <Form.Label>
                  Last Name<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Last Name"
                  {...register("last_name", { required: true, maxLength: 100 })}
                />
              </Form.Group>
              {errors.last_name?.type === "required" && (
                <p role="alert" className="text-danger fs-9 pt-1 mb-0">
                  Last Name is Required
                </p>
              )}
            </Col>
            <Col lg={6}>
              <Form.Group>
                <Form.Label>
                  Email<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Email"
                  {...register("email", { required: true, maxLength: 80 })}
                />
              </Form.Group>
              {errors.email?.type === "required" && (
                <p role="alert" className="text-danger fs-9 pt-1 mb-0">
                  Email is required
                </p>
              )}
            </Col>
            <Col lg={6}>
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="tel"
                  inputMode="tel"
                  placeholder="Phone"
                  {...register("phone", { maxLength: 80 })}
                />
              </Form.Group>
            </Col>

            {/* <Col lg={6}>
              <Form.Group>
                <Form.Label className="form-label-header mb-2">Role</Form.Label>
                <Form.Select {...register("role", { required: true })}>
                  <option value="" disabled selected>
                    Select Role
                  </option>
                  {collaboratorRole.map((item: any, i: any) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col> */}
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-0 p-0">
          <Button
            variant="link"
            className="text-danger px-3 my-0"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            type="submit"
            className="my-0"
            loading={loading}
          >
            Send Invitation
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddCollaboratorModal;
